import Person        from '@/domains/Persons/Person';
import Partner       from '@/domains/Partners/Partner';
import TimeStamp     from '@/core/types/TimeStamp';
import EntityPointer from '@/domains/EntityPointer/EntityPointer';

/**
 * Запись лога уведомлений — зеркало NotificationsLogEntry.php.
 *
 * Иммутабельна, не наследует BaseEntity. Только данные + fromServer.
 * Форматирование («уведомил(а)», список получателей строкой) — во view-слое.
 */
class NotificationLogEntry {

	id: number;
	eventTime: TimeStamp;

	author: Person | null = null;
	partner: Partner | null = null;

	ip: string | null = null;
	userAgent: string | null = null;

	/** Сущность, к которой относится уведомление. null — общесистемное. */
	parentEntity: EntityPointer | null = null;

	title: string | null = null;

	/** Получатели уведомления. */
	receivers: Person[] = [];

	realReceiverEmail: string | null = null;
	isEmailSpoofed: boolean = false;

	static fromServer(data: any, result = new NotificationLogEntry()): NotificationLogEntry {
		const entry = result;

		entry.id                = data.id;
		entry.eventTime         = TimeStamp.fromServer(data.eventTime ?? data.time);
		entry.ip                = data.ip ?? null;
		entry.userAgent         = data.userAgent ?? null;
		entry.title             = data.title ?? null;
		entry.realReceiverEmail = data.realReceiverEmail ?? null;
		entry.isEmailSpoofed    = data.isEmailSpoofed ?? false;

		if (data.author) {
			entry.author = Person.fromServer(data.author);
		}

		if (data.partner) {
			entry.partner = Partner.fromServer(data.partner);
		}

		if (data.parentEntity) {
			entry.parentEntity = EntityPointer.fromServer(data.parentEntity);
		}

		if (Array.isArray(data.receivers)) {
			entry.receivers = data.receivers.map((_item) => Person.fromServer(_item));
		}

		return entry;
	}
}

export default NotificationLogEntry;
